import { getEnv } from 'endpoints';

const injectStyle =  ( css, el ) => {

    const parent = document[ el ];

    const style = document.createElement( 'style' );
    style.type = 'text/css';

    style.appendChild( document.createTextNode( css ) );

    parent.appendChild( style );
};

export function createStyles( branding, parentEl ) {
    let css = null;
    let primary = '';
    let secondary = '';
    let logo = '';
    let background = '';

    function hexToRgb( hex ) {
        let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec( hex );
        return result ? {
            r: parseInt( result[ 1 ], 16 ),
            g: parseInt( result[ 2 ], 16 ),
            b: parseInt( result[ 3 ], 16 )
        } : null;
    }

    const rgbPrimary = hexToRgb( branding.primaryColor );

    if ( branding.primaryColor ) {
        primary = `
            .primary-color { color: ${ branding.primaryColor } !important; }
            .primary-background { background: ${ branding.primaryColor } !important; }
            .primary-background-avatar { background-color: ${ branding.primaryColor } !important; }
            .primary-fill { fill: ${ branding.primaryColor } !important; }
            .primary-border { border-color: ${ branding.primaryColor } !important; }
            .primary-border:hover { border-color: ${ branding.primaryColor } !important; }
            .primary-hover:hover { color: ${ branding.primaryColor } !important; }
            .primary-highlight.highlighted {background-color: rgba( ${ rgbPrimary.r }, ${ rgbPrimary.g }, ${ rgbPrimary.b }, .05 ) !important; }
            .primary-highlight.ant-menu-item-selected {background-color: rgba( ${ rgbPrimary.r }, ${ rgbPrimary.g }, ${ rgbPrimary.b }, .05 ) !important; }
            .primary-highlight:active {background-color: rgba( ${ rgbPrimary.r }, ${ rgbPrimary.g }, ${ rgbPrimary.b }, .05 ) !important; }
            .primary-highlight-hover:hover {background-color: rgba( ${ rgbPrimary.r }, ${ rgbPrimary.g }, ${ rgbPrimary.b }, .05 ) !important;}
        `;
    }

    if ( branding.secondaryColor ) {
        secondary = `
            .secondary-color { color: ${ branding.secondaryColor } !important; }
            .secondary-background { background: ${ branding.secondaryColor } !important; }
            .secondary-fill { fill: ${ branding.secondaryColor } !important; }
            .secondary-border { border-color: ${ branding.secondaryColor } !important; }
        `;
    }

    if ( branding.primaryLogo ) {
        logo = `
            .primary-logo { background-image: url("${ branding.primaryLogo }"); }
        `;
    }

    if ( branding.backgroundImage ) {
        background = `
            body { background-image: url("${ branding.backgroundImage }") !important; }
        `;
    } else {
        background = `
            body { background-image: url("https://api.biw.cloud/v1/images/background-image.png") !important; }
        `;
    }

    css = `${ primary }${ logo }${ secondary }${ background }`;

    injectStyle( css, parentEl );
    return css;
}

export function createTemplateLink( companyId, parentEl ) {
    const env = getEnv();
    const parent = document[ parentEl ];
    const link = document.createElement( 'link' );
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.href = `https://biw-imagestest--imagestest--${ env }.s3-us-west-2.amazonaws.com/${ companyId }.css`;

	parent.appendChild( link );
}